import { Input } from "reactstrap";
import NumberFormatter from "../../commons/NumberFormatter";

const PriceBasicInput = (props) => {
  const onChange = (e) => {
    let value = e.target.value.replace(/[^\d\.]/g, "");
    // Levágja azokat a tizedesjegyeket, amiket a megengedett tizedesjegy számon felül vannak, valamint a tizedespontot, ha 0 a megengedett tizedesjegyek száma
    let maxTizedesjegy = props.maxTizedesjegy == undefined ? 6 : props.maxTizedesjegy;
    let regExpString = "(?<=\\.\\d{"+maxTizedesjegy+"})\\d*";
    if (maxTizedesjegy === 0)
      regExpString+="|\\.$";
    value = value.replace(new RegExp(regExpString, "g"), "");
    value = NumberFormatter.addSpacesToString(
      value,
      NumberFormatter.OSSZEG,
      false
    );
    return props.onChange(value);
  };
  return (
    <>
      <label>
        {props.label}
        <Input
          // Specifikusan a NaN stringet kell szűrni, nem azt hogy a szám ténylegesen NaN, pl "10 000" NaN, de itt helyes bemenet
          value={props.value === 'NaN' ? '' : NumberFormatter.addSpacesToString(props.value, NumberFormatter.OSSZEG)}
          disabled={props.disabled}
          onChange={onChange}
          style={{ textAlign: "right" }}
        />
      </label>
    </>
  );
};

export default PriceBasicInput;
